import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "No 4-hour drive to Denver — we handle agency submission",
      "Ideal for Casper College students studying abroad",
      "Perfect for energy sector professionals on international rotations",
      "Great for outdoor guiding industry summer contracts overseas",
      "Casper/Natrona County International Airport (CPR) flyers",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no Denver drive required",
      "Faster than self-service at Casper post office",
      "Good for planned international trips from CPR via Denver",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Casper USPS is primary acceptance facility",
      "No document review — errors cause rejection and restart",
      "In-person clerk appointment required at Natrona County facilities",
      "Wyoming mail routing adds extra transit days",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "No passport agency in Wyoming — closest is Denver, ~270 miles via I-25",
      "4+ hour drive to Denver Regional Agency",
      "NPIC appointment required — no walk-ins at Denver agency",
      "Life-or-death emergencies only with documentation",
      "Highway closures in winter can make Denver unreachable",
      "Expect to lose a full day driving round-trip",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Casper"
      headingExtra="WY"
      introText="Casper travelers — Casper College students heading overseas, energy sector professionals on international rotations, outdoor adventure guides with summer contracts abroad, and CPR airport flyers — have several options for getting a passport fast. Here is how they compare, and why most Wyoming residents choose a U.S. Department of State registered passport courier rather than making the 270-mile drive to Denver."
      options={options}
      emergencyDescription="Wyoming has no regional passport agency. The closest is in Denver — a 270-mile, 4+ hour drive one-way via I-25. NPIC appointment required. Winter highway closures on I-25 can make Denver unreachable on short notice."
      disclaimerText="*Processing speed depends on eligibility and documentation. Wyoming has no passport agency — the closest is Denver, CO (~270 miles). Not all applicants qualify for Regional Agency Processing."
    />
  );
}